<script lang="ts">
  import CategorySection from './CategorySection.svelte'
  import filters from '../lib/stores/filters'
  import type { Filter } from '../global'
  import Label from './Label.svelte'

  export let label: string
  export let checkboxes: Filter.Checkbox[]
</script>

<CategorySection>
  <div class="flex flex-col gap-3">
    <Label class="block" as="div">
      {label}
    </Label>
    <div class="grid gap-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
      {#each checkboxes as { label, value } (`type-${value}`)}
        <label class="inline-flex cursor-pointer items-center">
          <input
            class="checkbox"
            type="checkbox"
            name="type[]"
            {value}
            bind:group={$filters.accommodationTypes}
          />
          <span class="ml-2">{label}</span>
        </label>
      {/each}
    </div>
  </div>
</CategorySection>
